import { render, staticRenderFns } from "./caseInfo.vue?vue&type=template&id=65104a3a&"
import script from "./caseInfo.vue?vue&type=script&lang=js&"
export * from "./caseInfo.vue?vue&type=script&lang=js&"
import style0 from "./caseInfo.vue?vue&type=style&index=0&id=65104a3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports